import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
const CACHE_RESET_VERSION = '2026-03-21-2';
const CACHE_RESET_STORAGE_KEY = 'sw-cache-reset-version';
const CACHE_RESET_RELOAD_KEY = 'sw-cache-reset-reloaded';
const clearServiceWorkerAndCaches = async () => {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
    if ('caches' in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.map((cacheKey) => caches.delete(cacheKey)));
    }
};
const disableServiceWorkerCaching = async () => {
    if (!('serviceWorker' in navigator)) {
        return;
    }
    const resetVersion = localStorage.getItem(CACHE_RESET_STORAGE_KEY);
    const hasReloaded = sessionStorage.getItem(CACHE_RESET_RELOAD_KEY) === CACHE_RESET_VERSION;
    if (resetVersion !== CACHE_RESET_VERSION) {
        await clearServiceWorkerAndCaches();
        localStorage.setItem(CACHE_RESET_STORAGE_KEY, CACHE_RESET_VERSION);
        sessionStorage.setItem(CACHE_RESET_RELOAD_KEY, CACHE_RESET_VERSION);
        return;
    }
    if (!hasReloaded) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        const cacheKeys = 'caches' in window ? await caches.keys() : [];
        if (registrations.length > 0 || cacheKeys.length > 0) {
            await clearServiceWorkerAndCaches();
            sessionStorage.setItem(CACHE_RESET_RELOAD_KEY, CACHE_RESET_VERSION);
            window.location.reload();
            return;
        }
    }
    sessionStorage.removeItem(CACHE_RESET_RELOAD_KEY);
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(React.createElement(React.StrictMode, null,
    React.createElement(App, null)));
// 临时停用 Service Worker 缓存
void disableServiceWorkerCaching();
